const SvgCommunity4 = (props) => (
  <>
    <circle cx={80} cy={16.05} r={12} fill={props.p40} />
    <circle cx={16} cy={16.05} r={12} fill={props.p40} />
    <circle cx={80} cy={80.05} r={12} fill={props.p40} />
    <circle cx={48} cy={48.05} r={12} fill={props.p40} />
    <circle cx={16} cy={80.05} r={12} fill={props.p40} />
  </>
);

export default SvgCommunity4;
